import { ReactElement } from 'react';
import { Button, Dialog, DialogTrigger } from '@ff-it/ui';
import { SettingsDialog } from './Settings';

export function SettingsButton(): ReactElement {
  return (
    <Dialog>
      <DialogTrigger>
        <Button variant="secondary" testId="toggle-settings" icon="gear" size="sm" title="Settings" />
      </DialogTrigger>
      <SettingsDialog />
    </Dialog>
  );
}
